module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Clock-926a04ecaf54314daa1bec9d1b264e25.svg";